import React from "react";
import { Menu, Dropdown, } from "antd";
import { connect } from "react-redux";
import 'flag-icons/css/flag-icons.min.css';

export const NavCountry = (props) => {
    const { country, currency } = props;

    const detailsMenu = (
        <div className="nav-profile nav-dropdown">
            <div className="nav-profile-header">
                <div className="d-flex">
                    <span className={"fi fi-" + (country?.isoCode?.toLowerCase() || "") + " mr-2"} style={{ fontSize: 50 }}></span>
                    <div className="pl-3">
                        <h4 className="mb-0">{country?.name} ({country?.isoCode})</h4>
                        <p className="mb-0">{currency?.code} ({currency?.symbol})</p>
                    </div>
                </div>
            </div>
        </div>
    );


    return (
        <>
            <Dropdown
                placement="bottomRight"
                overlay={detailsMenu}
                trigger={["click"]}
            >
                <Menu className="d-flex align-item-center" mode="horizontal">
                    <Menu.Item key="profile">
                        <span className={"fi fi-" + (country?.isoCode?.toLowerCase() || "")}></span>
                    </Menu.Item>
                </Menu>
            </Dropdown>
        </>
    );
};

const mapStateToProps = ({ auth }) => {
    const { username, role, code, country, currency } = auth;
    return { username, role, code, country, currency };
};

export default connect(mapStateToProps, {})(NavCountry);
